import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpClient } from '@angular/common/http';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class AutomaticDataGenerationService {
  static ENV = environment;

  constructor(private httpService: HttpService) { }

  public getParamsReportsWS(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(AutomaticDataGenerationService.ENV.environment.API.get_report_ws, data, httpRequesthandler);
  }

  public schedule_report_ftp(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(AutomaticDataGenerationService.ENV.environment.REPORTS.schedule_report_ftp, data, httpRequesthandler);
  }

  public jobSocket(params: string, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(encodeURI(`${AutomaticDataGenerationService.ENV.environment.REPORTS.jobSocket}${params}`), httpRequesthandler);
  }

  public cancelJob(params: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${AutomaticDataGenerationService.ENV.environment.REPORTS.cancel_jobs}${params}`, httpRequesthandler);
  }

  public revokeTask(process_id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${AutomaticDataGenerationService.ENV.environment.API.revoke_task}/${process_id}`, httpRequesthandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/automatic-data-generation/automatic-data-generation.service.ts